import { BlogPost } from '@/types/blog';
import { content } from './content';
import hochsensibleFuehrungHero from '@/assets/blog/hochsensible-fuehrung-hero.webp';

export const hochsensibleFuehrungPost: BlogPost = {
  title: 'Führung als hochsensibler Mensch: Warum feine Wahrnehmung wertvoll sein kann',
  metaTitle: 'Hochsensibel führen: Stärken, Strategien & Wissenschaft (HSP)',
  subtitle: 'Sensibilität als Stärke in einer komplexen Arbeitswelt',
  excerpt: 'Hochsensible Führungskräfte bringen Empathie, Reflexionsfähigkeit und ein feines Gespür für Teamdynamiken mit. Warum das in der modernen Arbeitswelt ein echter Vorteil ist.',
  metaDescription: 'Wie führt man erfolgreich, ohne auszubrennen? Praxis-Strategien & wissenschaftliche Insights für hochsensible Führungskräfte. Jetzt im Blog lesen.',
  date: '08.03.2026',
  lastUpdated: '18.03.2026',
  slug: 'hochsensible-fuehrung',
  imageUrl: hochsensibleFuehrungHero,
  category: 'Führung',
  tags: ['Führung', 'Hochsensibilität', 'HSP', 'Psychologische Sicherheit', 'Empathie', 'Selbstführung', 'Führung als hochsensibler Mensch'],
  author: 'Jörg Hörmann',
  authorTitle: 'Executive Coach',
  content
};
